'use strict';

var util = require('_core_ext/util'),
    JSConstants = require('_core_ext/pages/search/constants'),
    CSSConstants = require('_core_ext/cssconstants'),
    layout = require('_core_ext/layout');

var $cache = {},
    openedRefinements = [],
    applyUpdate = false,
    searchBrandString = '',
    searchVenueString = '',

    priceParamMin = Constants.PRICE_MIN_PARAMETER,
    priceParamMax = Constants.PRICE_MAX_PARAMETER;

function initializeCache() {
    $cache.container = $(JSConstants.CLASS_MAIN);
    $cache.body = $(JSConstants.CLASS_BODY);
    $cache.folderRefinement = $(JSConstants.CLASS_FOLDER_REFINEMENT);
}

function checkSelectedRefinements() {
    var $selectedRefinement = $('.js-refinement-dialog .js-selected');
    if ($selectedRefinement.length) {
        $(JSConstants.CLASS_REFINEMENT_SECTION).hide();
        $(JSConstants.CLASS_REFINEMENT_CLOSE_SECTION).show();
    }
}

function initDialogState(event) {
    if (!layout.isMobile()) {
        return;
    }

    $(JSConstants.CLASS_REFINEMENT_BRANDS_SEARCH).on('input', searchBrands);
    $(JSConstants.CLASS_REFINEMENT_VENUE_SEARCH).on('input', searchVenues);

    if (applyUpdate) {
        $(JSConstants.CLASS_REFINEMENT_APPLY)
            .addClass(CSSConstants.ACTIVE);
    } else {
        $(JSConstants.CLASS_REFINEMENT_APPLY)
            .removeClass(CSSConstants.ACTIVE);
    }

    initRefirementBlock(event);

    var $dialog = $(JSConstants.CLASS_REFINEMENT_DIALOG),
        $firstOpenedRefinement = $dialog.find(JSConstants.CLASS_REFINEMENTS_HEADER)
            .not('.' + CSSConstants.EXPANDED).first();

    if ($firstOpenedRefinement.length) {
        $dialog.scrollTop($firstOpenedRefinement.position().top);
        initUiSlider($dialog);
    }
}

function initRefirementBlock (event) {
    let isDialogOpen = !!event;
    let isSort = event && event.data ? event.data.isSort : false;

    if (isSort) {
        closeRefirements();
    }

    $(JSConstants.CLASS_REFINEMENTS_HEADER).each(function() {
        let refinementAttribute = $(this).parent().data('refinement-attribute');
        let force = false;

        if (refinementAttribute === 'sort-by') {
            if (isSort) {
                openedRefinements.push(refinementAttribute);
            } else if (isDialogOpen) {
                $(this).removeClass(CSSConstants.EXPANDED);
                force = true;
            }
        }

        updateRefirementState($(this), force);
    });

}

function closeRefirements() {
    getRefirements().each(function() {
        var $header = $(this).removeClass(CSSConstants.EXPANDED);
        updateRefirementState($header, true);
    });
}

function getRefirements() {
    var wrapperClass = layout.isMobile() ? JSConstants.CLASS_SORT_REFINEMENT_WRAPPER : JSConstants.CLASS_PLP_SEARCH_OPTIONS;
    return $(wrapperClass).find(JSConstants.CLASS_REFINEMENTS_HEADER);
}
/* eslint-disable no-unused-vars */
function hasOpenRefirements() {
    return openedRefinements.length > 0;
}

function updateRefirementState($header, force) {
    var $container = $header.siblings(JSConstants.CLASS_REFINEMENTS_CONTAINER),
        refinementAttribute = $header.closest('[data-refinement-attribute]').data('refinement-attribute'),
        elementIndex = openedRefinements.indexOf(refinementAttribute),
        isOpened = $header.hasClass(CSSConstants.EXPANDED) || (!force && elementIndex >= 0);

    if (isOpened && elementIndex < 0) {
        openedRefinements.push(refinementAttribute);
    } else if (!isOpened && elementIndex >= 0) {
        openedRefinements.splice(elementIndex, 1);
    }

    if (isOpened) {
        $header.addClass(CSSConstants.EXPANDED);
        $container.show();
    } else {
        $header.removeClass(CSSConstants.EXPANDED);
        $container.hide();
    }

    return isOpened;
}

function setRefinementsScrollTop(setItem, setValue, setDuration, clearScroll) {
    var setInterval = typeof(setDuration) !== 'undefined' ? setDuration : 500,
        setElement = typeof(setItem) !== 'undefined' ? setItem : 'html, body';

    if (clearScroll) {
        $(setElement).animate({scrollTop: 0}, 0);
    }

    $(setElement).animate({scrollTop: setValue}, setInterval);
}

function openDialog(event) {
    $cache.filterRefinementWrapper = $(JSConstants.CLASS_SORT_REFINEMENT_WRAPPER);

    $cache.filterRefinementWrapper.dialog({
        dialogClass: 'refinement-dialog js-refinement-dialog',
        open: function() {
            initDialogState(event);
        }
    });

    $cache.body.trigger('layout.lock');
    checkSelectedRefinements();

    $cache.body.on('click', JSConstants.CLASS_REFINEMENTS_HEADER, function () {
        if (layout.isMobile()) {
            setRefinementsScrollTop(JSConstants.CLASS_REFINEMENT_DIALOG, $(this).position().top, 100, true);
        }
    });
}

function openArticleDialog() {
    if (layout.isMobile()) {
        $cache.folderRefinement.dialog({
             dialogClass: 'refinement-dialog js-refinement-dialog'
        });
        $cache.body.trigger('layout.lock');
    }
}

function closeDialog(e) {
    e.preventDefault();

    var $desktop = $(JSConstants.CLASS_MAIN);
    var $updatedRefinements = $desktop.find(JSConstants.CLASS_SORT_REFINEMENT_WRAPPER);

    // close if nothing has beed changed
    // or remove if content has been updated ( updatedRefinements exists)
    if ($updatedRefinements.length && $cache.filterRefinementWrapper.data('ui-dialog')) {
        $cache.filterRefinementWrapper.dialog('destroy').remove();
        delete $cache.filterRefinementWrapper;
    } else {
        $cache.filterRefinementWrapper.dialog('close');
    }

    $cache.folderRefinement.dialog('close');
    openedRefinements = [];
    applyUpdate = false;

    $cache.body.trigger('layout.unlock');
}

function ajaxReloadHandler(e) {
    e.stopPropagation();
    e.preventDefault();

    // don't intercept for category and folder refinements, as well as unselectable
    var $this = $(this),
        targetURL = this.href || $this.data('href'),
        categoryRefinementLength = $this.parents(JSConstants.CLASS_CATEGORY_REFINEMENT).length,
        folderRefinementLength = $this.parents(JSConstants.CLASS_FOLDER_REFINEMENT).length,
        isSelectable = !$this.parent().hasClass(JSConstants.CLASS_UNSELECTABLE);

    if (!layout.isMobile()) {
        closeSortSelect(e);
    }

    if (categoryRefinementLength > 0 || folderRefinementLength > 0 || !isSelectable) {
        return;
    }

    applyUpdate = true;

    $cache.container.trigger('search.update', {
        'targetURL': targetURL
    });
}

function appendPriceRefinementToUrl($form, priceRefinement) {
    var url = $form.attr('action'),
        priceMin = priceRefinement[0],
        priceMax = priceRefinement[1];

    if (!priceRefinement) {
        return url;
    }

    if (priceMin) {
        url = util.appendParamToURL(url, 'pmin', priceMin);
    }
    if (priceMax) {
        url = util.appendParamToURL(url, 'pmax', priceMax);
    }

    return url;
}

function composeCustomPriceUrlFromForm($form) {
    var selector = '[name="{0}"]',
        $priceMin = $form.find(String.format(selector, priceParamMin)),
        $priceMax = $form.find(String.format(selector, priceParamMax)),
        $priceMinValue = $priceMin.val(),
        $priceMaxValue = $priceMax.val();

    var $defaults = $form.closest('.js-refinements_container').find('.js-refinement_price .js-ui_slider').data('values');
    if ($defaults) {
        if ($priceMaxValue.length === 0 && $defaults.categoryMax) {
            $priceMaxValue = $defaults.categoryMax;
        }
    }

    var priceRange = [$priceMinValue, $priceMaxValue];

    return appendPriceRefinementToUrl($form, priceRange);
}

function isAllowedNumericKey(key) {
    var pattern = /^\d+$/;
    return pattern.test(String.fromCharCode(key));
}

function checkPriceEqualHandler() {
    var $refinementMinPrice = $(JSConstants.CLASS_MIN_PRICE).eq(1),
        $refinementMaxPrice = $(JSConstants.CLASS_MAX_PRICE).eq(1),
        $priceSlider = $(JSConstants.CLASS_REFINEMENT_PRICE).find(JSConstants.CLASS_UI_SLIDER);

    var minPrice = parseFloat($refinementMinPrice.val()),
        maxPrice = parseFloat($refinementMaxPrice.val());

    if (minPrice === maxPrice) {
        maxPrice = maxPrice + 1;
        $refinementMaxPrice.val(maxPrice);
    } else if (minPrice > maxPrice && maxPrice !== 0) {
        minPrice = minPrice + 1;
        $refinementMinPrice.val(minPrice);
    }

    if ($priceSlider.length) {
        var priceData = $priceSlider.data('values') || {};

        if (minPrice < priceData.categoryMin) {
            minPrice = priceData.categoryMin;
            $refinementMinPrice.val(minPrice);
        }
        if (maxPrice > priceData.categoryMax) {
            maxPrice = priceData.categoryMax;
            $refinementMaxPrice.val(maxPrice);
        }
        if (maxPrice < minPrice) {
            $refinementMaxPrice.val(minPrice);
        }
    }
}

function searchRefinements(searchValue, refinements, type) {
    var regEx = new RegExp('(?:^|\\s)' + searchValue.toLowerCase());
    $.each($(refinements), function() {
        var $this = $(this);
        if ($this.data(type)) {
            if (regEx.test($this.data(type).toLowerCase())) {
                $this.removeClass(CSSConstants.HIDDEN);
            } else {
                $this.addClass(CSSConstants.HIDDEN);
            }
        }
    });
}

function searchVenues() {
    var $this = $(this);
    searchVenueString = $this.val();
    searchRefinements($this.val(), JSConstants.CLASS_REFINEMENT_VENUE, 'venuename');
}

function searchBrands() {
    var $this = $(this);
    searchBrandString = $this.val();
    searchRefinements($this.val(), JSConstants.CLASS_REFINEMENT_BRAND, 'brandname');
}

function initUiSlider($container) {
    var uiSlider = $container.find(JSConstants.CLASS_UI_SLIDER)[0];

    if (uiSlider) {

        if (uiSlider.noUiSlider) {
            uiSlider.noUiSlider.destroy();
        }

       var data = $(uiSlider).data('values') || {};

        noUiSlider.create(uiSlider, {
            connect: true,
            behaviour: 'tap',
            start: [data.refinedMin || data.categoryMin, data.refinedMax || data.categoryMax],
            range: {
                'min': [data.categoryMin],
                'max': [data.categoryMax]
            },
            format: wNumb({
                decimals: 0,
                prefix: Constants.CURRENCY_SYMBOL,
            })
        });

        var minPrice = $container.find(JSConstants.CLASS_MIN_PRICE)[0],
            maxPrice = $container.find(JSConstants.CLASS_MAX_PRICE)[0],
            inputs = [minPrice, maxPrice];

        uiSlider.noUiSlider.on('update', function(values, handle) {
            var value = values[handle];
            updatePriceMargins($container, handle ? value : null, !handle ? value : null);
        });

        // Clears pmin and pmax input values if prices were not submitted
        if (!data.refinedMin) {
            $(minPrice).val('');
        }

        if (!data.refinedMax) {
            $(maxPrice).val('');
        }

        uiSlider.noUiSlider.on('change', function(values, handle) {
            var value = values[handle];

            $(inputs[handle]).val(value.replace(/[^\d]/g, ''));
        });
    }
}

function updatePriceMargins($container , maxLabel, minLabel) {
    var $marginMin = $container.find(JSConstants.CLASS_MIN_LABEL),
        $marginMax = $container.find(JSConstants.CLASS_MAX_LABEL);

    if ($marginMax.length && maxLabel) {
        $marginMax.html(maxLabel);
    }

    if ($marginMin.length && minLabel) {
        $marginMin.html(minLabel);
    }
}

function initializeEvents() {
    $cache.container
        .on('input', JSConstants.CLASS_REFINEMENT_BRANDS_SEARCH, searchBrands)
        .on('input', JSConstants.CLASS_REFINEMENT_VENUE_SEARCH, searchVenues);

    if (layout.isMobile()) {
        $cache.container
            .on('click', JSConstants.CLASS_FILTER_BY_LINK, openDialog);
        $cache.container
            .on('click', JSConstants.CLASS_SORT_BY_LINK, {isSort: true}, openDialog);
    }

    $cache.body
        .on('click', JSConstants.CLASS_BREADCRUMB_REFINEMENT_VALUE, ajaxReloadHandler)
        .on('click', JSConstants.CLASS_REFINEMENT_LINK, ajaxReloadHandler)
        .on('click', JSConstants.CLASS_REFINEMENT_CLOSE, closeDialog)
        .on('click', JSConstants.CLASS_REFINEMENT_HEADER_SEARCH, openArticleDialog)
        .on('change', JSConstants.CLASS_PRICE_REFINEMENT + ' :input', checkPriceEqualHandler)
        .on('submit', JSConstants.CLASS_PRICE_REFINEMENT, function(e) {
            e.preventDefault();
            checkPriceEqualHandler();

            var $this = $(this),
                href = composeCustomPriceUrlFromForm($this);

            if (!href) {
                return;
            }

            applyUpdate = true;
            $cache.container.trigger('search.update', {
                'targetURL': href
            });
        })
        .on('keypress', JSConstants.CLASS_PRICE_REFINEMENT + ' input', function(e) {
            var key = (e.keyCode || e.charCode);

            if (key === 13) {
                return;
            } else if (!isAllowedNumericKey(key)) {
                e.preventDefault();
            }
        })
        .on('click', JSConstants.CLASS_REFINEMENTS_HEADER, function () {
            var $this = $(this),
                expandedClass = CSSConstants.EXPANDED,
                isOpened = $this.hasClass(expandedClass);

            closeRefirements();
            if (!isOpened) {
                $this.addClass(expandedClass);
            } else {
                $this.removeClass(expandedClass);
            }

            updateRefirementState($this, true);
        });

    if (!layout.isMobile()) {
        // close sort selector if click outside
        $cache.body.on('click', function(e) {
            closeSortSelect(e);
        });

        // close sort dropdown when a sort option is selected (desktop & tablet only)
        $cache.body.on('click', JSConstants.CLASS_SORT_REFINEMENT_DROPDOWN + ' ' + JSConstants.CLASS_REFINEMENT_LINK, function() {
            var $sortDropdown = $(JSConstants.CLASS_SORT_REFINEMENT_DROPDOWN);
            var $sortDropdownHeader = $sortDropdown.find(JSConstants.CLASS_REFINEMENTS_HEADER);
            var $container = $sortDropdown.children(JSConstants.CLASS_REFINEMENTS_CONTAINER);
            var elementIndex = openedRefinements.indexOf('sort-by');

            $sortDropdownHeader.removeClass(CSSConstants.EXPANDED);
            $container.hide();

            if (elementIndex >= 0) {
                openedRefinements.splice(elementIndex, 1);
            }
        });
    }

    $(document).on('products.loaded', function() {
        $.each($(JSConstants.CLASS_REFINEMENT_BRANDS_SEARCH),function() {
            $(this).val(searchBrandString || '').trigger('input');
        });
        $.each($(JSConstants.CLASS_REFINEMENT_VENUE_SEARCH), function() {
            $(this).val(searchVenueString || '').trigger('input');
        });
    });
}

function closeSortSelect(e) {
    var sortDropdownClass = JSConstants.CLASS_SORT_REFINEMENT_DROPDOWN;
    var $sortDropdown = $(sortDropdownClass);
    var $sortDropdownHeader = $sortDropdown.find(JSConstants.CLASS_REFINEMENTS_HEADER);
    var $this = $(e.target);
    var isInsideSortClicked = $this.hasClass(sortDropdownClass.substring(1)) ||
        $this.parents(sortDropdownClass).length > 0;

    if (!isInsideSortClicked && $sortDropdownHeader.hasClass(CSSConstants.EXPANDED)) {
        var $container = $sortDropdown.children(JSConstants.CLASS_REFINEMENTS_CONTAINER),
            elementIndex = openedRefinements.indexOf('sort-by');

        $sortDropdownHeader.removeClass(CSSConstants.EXPANDED);
        $container.hide();

        if (elementIndex >= 0) {
            openedRefinements.splice(elementIndex, 1);
        }
    }
}

var refinements = {
    init: function() {
        initializeCache();
        initializeEvents();
        initUiSlider($(JSConstants.CLASS_MAIN));

        if (!layout.isMobile()) {
            initRefirementBlock();
        }
    },
    initUiSlider: initUiSlider,
    checkSelectedRefinements: checkSelectedRefinements,
    initDialogState: initDialogState,
    initRefirementBlock: initRefirementBlock,
    closeRefirements: closeRefirements
};

module.exports = refinements;
